import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { formatCurrency } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "center", alignSelf: "flex-start", marginRight: 25
    }
});

const OutstandingBalance = (props) => {
    const drAccounts = props.data?.filter(a => a.type.toUpperCase() === "DR");
    drAccounts?.sort((a, b) => a.accountName.localeCompare(b.accountName));
    const crAccounts = props.data?.filter(a => a.type.toUpperCase() === "CR");
    crAccounts?.sort((a, b) => a.accountName.localeCompare(b.accountName));
    const formatedData = [...drAccounts, ...crAccounts];
    formatedData?.forEach((element, index) => {
        element.srno = index + 1;
        element.balance = formatCurrency(element.balance);
    });

    const tableData = {
        columnName: ["Sr No", "Account Name", "Balance", "Type"],
        column: ["srno", "accountName", "balance", "type"],
        data: formatedData
    }

    return (
        <Page style={{ padding: 15 }} id={formatedData.id} orientation="landscape">
            <Fragment>
                <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                    <Text style={{
                        fontSize: 16,
                        flexDirection: "column",
                        flexGrow: 1
                    }}>{FIRM_NAME}</Text>
                </View>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${100 / tableData["columnName"].length}%`, fontSize: 9
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={styles.rowView}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${100 / tableData["column"].length}%`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
        </Page>
    );
}

export default OutstandingBalance;